export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Systems Assessment',
      description: 'We analyze your existing workflows, tools, and operational bottlenecks to identify the highest-impact opportunities.',
      icon: 'ri-search-line',
    },
    {
      number: '02',
      title: 'Architecture Design',
      description: 'We design an intelligent system tailored to your operations and industry requirements — no cookie-cutter solutions.',
      icon: 'ri-draft-line',
    },
    {
      number: '03',
      title: 'Deployment & Integration',
      description: 'AI workflows are deployed seamlessly into your existing environment — with training and support for your team.',
      icon: 'ri-rocket-line',
    },
    {
      number: '04',
      title: 'Optimization & Scale',
      description: 'We refine performance, expand capabilities, and support long-term growth as your operations evolve.',
      icon: 'ri-line-chart-line',
    },
  ];

  return (
    <section id="how-it-works" className="py-20 lg:py-28 bg-secondary">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <span className="text-primary text-sm font-semibold tracking-wider uppercase mb-3 block">
            Our Process
          </span>
          <h2 className="text-3xl lg:text-5xl font-display text-foreground mb-4 leading-tight">
            A Structured Approach to Breakthrough Results
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            A proven 4-step process to design, build, and optimize AI-powered automation for your organization.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative group">
              {/* Connecting line - only show on desktop and not for last item */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-px bg-gradient-to-r from-primary/30 to-transparent z-0"></div>
              )}

              <div className="relative z-10">
                <div className="w-20 h-20 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-all">
                  <i className={`${step.icon} text-3xl text-primary`}></i>
                </div>

                <span className="text-primary/40 text-sm font-display font-bold mb-2 block">
                  {step.number}
                </span>

                <h3 className="text-xl font-display font-semibold text-foreground mb-3">
                  {step.title}
                </h3>

                <p className="text-muted-foreground text-sm leading-relaxed">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}